acceptAll: Alle akzeptieren
acceptSelected: Ausgewählte akzeptieren
close: Schließen
consentModal:
  description: Unsere Webseiten verwenden Cookies, um die Bedienfreundlichkeit zu erhöhen. Wir bitten Sie, sogenannte Cookies für die Zwecke der Leistungsfähigkeit ihrer Website www.gontermann-peipers.de und deren Unterauftritte zu akzeptieren. Hier können Sie einsehen und anpassen, welche Information wir mit Hilfe dieser Cookies sammeln. Um mehr zu erfahren, lesen Sie bitte unsere Datenschutzerklärung.
  privacyPolicy:
    name: Datenschutzerklärung
    text: Um mehr zu erfahren, lesen Sie bitte unsere {privacyPolicy}.
  title: Dienste, die wir nutzen möchten
consentNotice:
  changeDescription: Seit Ihrem letzten Besuch gab es Änderungen, bitte erneuern Sie
    Ihre Zustimmung.
  description: Um unsere Website für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Sie können über „Einwilligung anpassen“ selbst entscheiden, welche optionalen Cookies bei der Nutzung der Website gesetzt werden sollen.
  imprint:
    name: Impressum
  learnMore: Einwilligung anpassen
  privacyPolicy:
    name: Datenschutzerklärung
  testing: Testmodus!
contextualConsent:
  acceptAlways: Immer
  acceptOnce: Nur jetzt
  description: Möchten Sie {title} (externer Inhalt) laden?
decline: Ich lehne ab
ok: Das ist ok
poweredBy: Realisiert mit Klaro!
privacyPolicy:
  name: Datenschutzerklärung
  text: Um mehr zu erfahren, lesen Sie bitte unsere {privacyPolicy}.
purposeItem:
  service: Dienst
  services: Dienste
purposes:
  necessary:
    title: Technisch notwendig
    description: Notwendige Cookies helfen uns dabei, diese Webseite nutzbar zu machen, indem sie Grundfunktionen wie zum Beispiel Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nur eingeschränkt funktionieren.
  services:
    title: Dienstbereitstellung
    description: Diese Dienste sind für die allgemeine Nutzung der Website nicht erforderlich, ermöglichen aber zusätzliche Funktionen.
  social:
    title: Einbindung sozialer Netzwerke
    description: Auf manchen Unterseiten werden Inhalte sozialer Netzwerke eingebunden. Sobald diese geladen werden, werden Daten an die Server der externen Dienste übermittelt und können von denen weiterverarbeitet werden.
  analytics:
    title: Besucher-Statistiken
    description: Statistik-Cookies helfen uns zu verstehen, wie Besucher mit unseren Seiten interagieren und wann und wie oft welche Seiten aufgerufen werden. Dazu werden Informationen anonymisiert gesammelt.
save: Speichern
service:
  disableAll:
    description: Mit diesem Schalter können Sie alle Dienste aktivieren oder deaktivieren.
    title: Alle Dienste aktivieren oder deaktivieren
  optOut:
    description: Diese Dienste werden standardmäßig geladen (Sie können sich jedoch abmelden)
    title: (Opt-out)
  purpose: Zweck
  purposes: Zwecke
  required:
    description: Dieser Service ist immer erforderlich
    title: (immer erforderlich)
geodata:
  title: Karten der Stadt Siegen
googleMaps:
  title: Karten von GoogleMaps